
<header></header>

<main class="unsubscribe__container">

  <p-heading tag="h1" size="2xl">
    {{ headline }}
  </p-heading>

  <p-heading
    tag="h2"
    size="lg"
    class="unsubscribe__subheadline">
    {{ subHeadline }}
  </p-heading>

  <p-text class="unsubscribe__description">
    {{ description }}
  </p-text>

  <div
    class="unsubscribe__email"
    *ngIf="!isUnsubscribedPage">

    <p-text>
      {{ mailAddressRemoval1 }}
    </p-text>

    <p-text weight="semibold">
      {{ email$ | async }}
    </p-text>

    <p-text>
      {{ mailAddressRemoval2 }}
    </p-text>

  </div>

  <div
    class="unsubscribe__action"
    *ngIf="buttonTxt">

    <p-button (click)="onClick()">
      {{ buttonTxt }}
    </p-button>

    <p-toast></p-toast>

  </div>

</main>

<footer></footer>
